@if (loading) {
  <myp-skeleton-loader type="workspace"></myp-skeleton-loader>
}

@if (!loading && workspace) {
  <div class="workspace-page" #container>
    <div class="d-flex d-md-flex justify-space-between align-items-center m-b-10">
      <div class="text-left workspace-title">
        <fui-heading [text]="workspace.name" [level]="5"></fui-heading>
      </div>
      <div class="text-right workspace-action">
        <span class="btn btn-secondary" (click)="editWorkspace()">{{ "general.settings" | translate }}</span>
      </div>
    </div>
    <div class="row m-b-10 d-lg-none" [class.d-none]="selectedView != 'details'" [class.d-block]="selectedView == 'details'">
      <div class="col">
        <div class="view-chooser-container d-flex">
          <div class="view-chooser neutral" style="width: 100%" [ngStyle]="{ opacity: batchOperationMode ? '0' : '1' }">
            <div class="option" [class.selected]="selectedView == 'timeline'" (click)="batchOperationMode ? '' : selectView('timeline')">{{ "sphere.workspaces.timeline" | translate }}</div>
            <div class="option" [class.selected]="selectedView == 'files'" (click)="batchOperationMode ? '' : selectView('files')">
              {{ "sphere.workspaces.shared_files" | translate }}
              @if (totalUnreadFileMessages) {
                <span class="unread-badge">{{ totalUnreadFileMessages }}</span>
              }
            </div>
            <div class="option d-block d-lg-none" [class.selected]="selectedView == 'details'" (click)="selectView('details')">{{ "sphere.details" | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex">
      @if (workspace) {
        <div
          class="d-lg-block workspace-sidebar"
          [style]="'width: ' + detailsWidth + '; margin-right: 15px; min-width: 300px;'"
          [class.d-none]="selectedView != 'details'"
          [class.d-block]="selectedView == 'details'"
        >
          <ng-container *ngTemplateOutlet="detailContent"></ng-container>
        </div>
      }
      <div class="d-lg-block overflow-hidden flex-fill" [class.d-none]="selectedView == 'details'" [class.d-block]="selectedView == 'timeline' || selectedView == 'files'">
        <div class="row m-b-10">
          <div class="col">
            <div class="view-chooser-container d-flex">
              <div class="view-chooser neutral" style="width: 100%" [ngStyle]="{ opacity: batchOperationMode ? '0' : '1' }">
                <div class="option" [class.selected]="selectedView == 'timeline'" (click)="batchOperationMode ? '' : selectView('timeline')">{{ "sphere.workspaces.timeline" | translate }}</div>
                <div class="option" [class.selected]="selectedView == 'files'" (click)="batchOperationMode ? '' : selectView('files')">
                  {{ "sphere.workspaces.shared_files" | translate }}
                  @if (totalUnreadFileMessages) {
                    <span class="unread-badge">{{ totalUnreadFileMessages }}</span>
                  }
                </div>
                <div class="option d-block d-lg-none" [class.selected]="selectedView == 'details'" (click)="selectView('details')">{{ "sphere.details" | translate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" #timelineFilesView style="overflow: hidden" [ngStyle]="{ height: timelineFilesViewHeight + 'px' }">
          <div class="col-md-12 h-full">
            <div
              ng2FileDrop
              class="discussion-files-view timeline-drop-zone"
              [class.hovering]="hasBaseDropZoneOver"
              (onFileDrop)="droppedFile($event)"
              [uploader]="uploader"
              (fileOver)="fileOverBase($event)"
            >
              @if (selectedView != "files" && !loadingTimeline && (!communityService.comments || !communityService.comments.length)) {
                <div class="timeline-instruction-overlay">
                  <div class="text-center">
                    @if (hasMessagesPermission) {
                      <span class="gothic">{{ "sphere.workspaces.timeline" | translate }}</span>
                    }
                    @if (myWorkspace && workspace.collaborators.length == 1) {
                      <div>
                        {{ "sphere.invite_collaborator" | translate }}
                        <br />
                        <br />
                        <button class="small-btn" (click)="manageCollaborators()">{{ "sphere.workspaces.manage_collaborators" | translate }}</button>
                      </div>
                    }
                    @if (hasMessagesPermission && ((myWorkspace && workspace.collaborators.length > 1) || !myWorkspace)) {
                      <div>Its awfully quiet in here. Send a message below!</div>
                    }
                  </div>
                </div>
              }
              @if (attingCollabs && attingCollabs.length) {
                <div class="atting-collabs">
                  @for (user of attingCollabs; track user) {
                    <div (click)="selectAtCollab(user)" class="pointer" [class.selected]="highlightedAtCollab.user_id == user.user_id">{{ user.name }}</div>
                  }
                </div>
              }
              <div class="h-full">
                @if (loadingTimeline && selectedView != "files") {
                  <div class="d-flex justify-content-center align-items-center t-30 h-full">
                    <myp-inline-loader [loading]="true" height="200px" spinnerName="timelineLoader"></myp-inline-loader>
                  </div>
                }
                @if (selectedView != "files" && workspace) {
                  <div class="h-full">
                    <div #chatWindow class="discussion-container h-full" [ngStyle]="{ 'border-radius': '10px 10px 0px 0px' }">
                      @if (!showingAllMessages && !loadingTimeline) {
                        <div class="text-center">
                          @if (displayedMessages.length == 100) {
                            <button class="small-btn" (click)="initMessages(true)">{{ "com.get_older_messages" | translate }}</button>
                          }
                        </div>
                      }
                      @for (msg of communityService.comments; track msg) {
                        @if (collaboratorMap[msg.author.id]) {
                          @if (msg.type == "message") {
                            <div class="msg-container" [class.me]="msg.author.id == user.id" [class.them]="msg.author.id != user.id">
                              <img [src]="collaboratorMap[msg.author.id].photo || './assets/images/default_avatar.jpg'" class="profile-photo" />
                              <div class="msg">
                                @if (msg.type == "message") {
                                  <span class="text" [innerHTML]="msg.htmlMessage | safe: 'html'"></span>
                                }
                                <span class="timestamp d-block">
                                  {{ msg.timestamp && msg.timestamp.toDate ? (msg.timestamp.toDate() | date: "MMM Do h:mma" : true) : "" }}
                                  @if (msg.author.id != user.id && msg.author.name != "null null") {
                                    <span>&nbsp;{{ msg.author.name }}</span>
                                  }
                                  @if (msg.edited) {
                                    <span class="c-gray">&nbsp;Edited</span>
                                  }
                                  <div>
                                    @if (msg.author.id == user.id || myWorkspace) {
                                      <button class="msg-options-link" (click)="msgOptions(msg)">{{ "sphere.options" | translate }}</button>
                                    }
                                  </div>
                                </span>
                              </div>
                            </div>
                          }
                          @if (msg.type == "file-uploaded") {
                            <div class="m-y-30 p-y-30 text-center">
                              <div class="d-flex justify-content-center align-items-center text-left m-b-10">
                                <img [src]="collaboratorMap[msg.author.id].photo || './assets/images/default_avatar.jpg'" class="profile-photo m-r-5" />
                                <div style="line-height: 13px">
                                  <span class="t-12 d-block">{{ msg.timestamp.toDate() | date: "MMM Do [at] h:mma" : true }}</span>
                                </div>
                              </div>
                              @if (workspaceService.imageFiles[msg.file.extension]) {
                                @if (msg.file.coverphoto == "1") {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.changed_cover_photo" | translate: { author: msg.author.name } }}
                                  </h6>
                                }
                                @if (msg.file.coverphoto != "1") {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.author_shared_image" | translate: { author: msg.author.name, type: msg.file.extension } }}
                                  </h6>
                                }
                                @if (msg.file.coverphoto != "1") {
                                  <h6 class="d-block m-b-10 t-12 bold">{{ msg.file.description }}</h6>
                                }
                                <ng-container>
                                  <div
                                    class="msg-image-container"
                                    *inView
                                    [ngStyle]="{
                                      'background-image': 'url(' + workspaceService.buildFileUrl(workspace.user_id, msg.file.workspace_id, msg.file) + ')',
                                    }"
                                    (click)="showImage(workspaceService.buildFileUrl(workspace.user_id, msg.file.workspace_id, msg.file))"
                                  ></div>
                                </ng-container>
                              }
                              @if (workspaceService.audioFiles[msg.file.extension]) {
                                @if (msg.file.mainmix) {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.author_updated_mix" | translate: { author: msg.author.name } }}
                                  </h6>
                                }
                                @if (!msg.file.mainmix && !msg.source) {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.author_shared_file" | translate: { author: msg.author.name, type: msg.file.extension } }}
                                  </h6>
                                }
                                @if (!msg.file.mainmix && msg.source) {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.author_shared_file_from" | translate: { author: msg.author.name, type: msg.file.extension, source: msg.source } }}
                                  </h6>
                                }
                                <h6 class="d-block m-b-10 t-12 bold">{{ msg.file.filename }}</h6>
                                @if (msg.file.description) {
                                  <h6 class="d-block m-b-10 t-12 bold">{{ msg.file.description }}</h6>
                                }
                                <div>
                                  <div class="play-btn mx-auto" (click)="playAudio(msg.file)">
                                    <fa-icon icon="play" class="m-r-10"></fa-icon>
                                    <span class="gothic">{{ "sphere.play" | translate }}</span>
                                  </div>
                                </div>
                              }
                              @if (!workspaceService.audioFiles[msg.file.extension] && !workspaceService.imageFiles[msg.file.extension]) {
                                @if (!msg.source) {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.author_shared_file" | translate: { author: msg.author.name, type: msg.file.extension } }}
                                  </h6>
                                }
                                @if (msg.source) {
                                  <h6 class="d-block m-b-10 t-12 bold">
                                    {{ "sphere.workspaces.author_shared_file_from" | translate: { author: msg.author.name, type: msg.file.extension, source: msg.source } }}
                                  </h6>
                                }
                                @if (msg.file.description) {
                                  <h6 class="d-block m-b-10 t-12 bold">{{ msg.file.description }}</h6>
                                }
                                <div class="generic-shared-timeline-file d-flex justify-content-center">
                                  <div class="d-flex content-bg">{{ msg.file.filename }}</div>
                                </div>
                                <span class="t-12 d-block">{{ msg.file.filesize | bytesToSize }}</span>
                              }
                              <button class="small-btn" (click)="msgFileClick(msg)">{{ "sphere.view_file_details" | translate }}</button>
                            </div>
                          }
                        }
                      }
                    </div>
                  </div>
                }
                @if (selectedView == "files" && workspace) {
                  <div class="h-full">
                    <myp-workspace-files
                      #workspaceFilesCmp
                      [workspace]="workspace"
                      (fileClicked)="fileItemClick($event)"
                      (fileDeleted)="fileDeleted($event)"
                      (downloadFileClicked)="downloadFile($event.event, $event.file)"
                      (msgOptionsClicked)="msgOptions(false, $event.file, $event.event)"
                      (playAudioClicked)="playAudio($event.file, $event.event)"
                      (fileSelectedForBatchOperation)="selectFileForBatchOperation($event)"
                      (batchOperationClicked)="toggleBatchOperationMode()"
                      [batchOperationMode]="batchOperationMode"
                      [collaboratorMap]="collaboratorMap"
                      [unReadCounts]="unReadCounts"
                    ></myp-workspace-files>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        @if (selectedView == "files") {
          @if (!batchOperationMode) {
            <div class="upload-file-btn" (click)="addFile()">
              {{ "sphere.workspaces.upload_file" | translate }} to
              {{ workspaceFilesCmp?.selectedFolder && workspaceFilesCmp?.selectedFolder != "Home" ? decodeName(workspaceFilesCmp.selectedFolder.filename) : "Home" }}
            </div>
          }
          @if (batchOperationMode && myRole != "browser") {
            <div class="upload-file-btn active">
              <span class="pointer" (click)="batchOperation('move')">{{ "sphere.workspaces.move_selected" | translate }}</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span class="pointer" (click)="batchOperation('delete')">{{ "sphere.workspaces.delete_selected" | translate }}</span>
            </div>
          }
        }
        @if (!loadingConversation && selectedView != "files" && hasMessagesPermission) {
          <div class="msg-input workspace-message-input" [ngStyle]="{ width: chatWidth + 'px', left: 'auto', opacity: uiMeasured ? '1' : '0' }">
            <myp-message-input
              #msgInput
              (returnPressed)="addMessage()"
              (loaded)="messageInputCmpLoaded($event)"
              type="span"
              [mentionSource]="true"
              [mentionDataSource]="collabsNotMe"
              (focus)="measureUI()"
              [inputID]="'message_input'"
              [placeholder]="'com.ctrl_enter' | translate"
              (valueChanged)="messageValueChange($event)"
              (inputHeightChange)="messageContainerHeightChange($event)"
              [includeSendButton]="true"
              [includeAttachmentButton]="!activeAttachment"
              (attachmentBtnClicked)="addFile()"
            ></myp-message-input>
          </div>
        }
      </div>
    </div>
  </div>
}

<ng-template #detailContent>
  <div class="image-container">
    @if (workspace.image) {
      <img class="w-full border-radius10 pointer image-border" (click)="showImage(workspace.image)" [src]="workspace.image" />
    }
  </div>
  @if (myWorkspace) {
    <button class="small-btn" (click)="changeImage()">
      {{ workspace.image ? ("sphere.account.change_cover_photo" | translate) : ("sphere.account.add_cover_photo" | translate) }}
    </button>
  }

  <div id="workspace-details">
    <div id="details-text" [class.expanded]="descriptionExpanded">
      <span #descTextSpan>{{ workspace.description ? workspace.description : ("sphere.workspaces.no_desc" | translate) }}</span>
    </div>
    @if (shouldShowShowMore) {
      <button class="small-btn" (click)="descriptionExpanded = !descriptionExpanded">
        {{ descriptionExpanded ? ("sphere.workspaces.show_less" | translate) : ("sphere.workspaces.show_more" | translate) }}
      </button>
    }
  </div>
  @if (workspace.mainmix) {
    <div class="m-t-20">
      <span class="t-16 bold brandfont-bold">{{ "sphere.workspaces.latest_mix" | translate }}</span>
      <br />
      <div>
        <div class="play-btn" (click)="playAudio(workspace.mainmix)">
          @if (contentService.loadingPlayId != workspace.mainmix.id) {
            <fa-icon icon="play" class="m-r-10"></fa-icon>
          }
          @if (contentService.loadingPlayId == workspace.mainmix.id) {
            <fa-icon icon="spinner" animation="spin" class="m-r-10"></fa-icon>
          }
          <span class="text-nowrap">{{ "sphere.workspaces.play_mix" | translate }}</span>
        </div>
        <div class="main-mix-details">
          {{ workspace.mainmix.filename }}
          <br />
          {{ workspace.mainmix.description }}
        </div>
        <button class="small-btn" (click)="addFile(true)">{{ "sphere.workspaces.upload_new_mix" | translate }}</button>
      </div>
    </div>
  }

  <div class="collaborators m-t-20">
    <span class="t-16 bold brandfont-bold">{{ "sphere.workspaces.collaborators" | translate }}</span>
    <br />

    @for (collab of workspace.collaborators; track collab) {
      <myp-list-item
        [photo]="collab.photo ? collab.photo : './assets/images/default_avatar.jpg'"
        [title]="((collab.name && collab.name != ' ' ? collab.name : false) || collab.email) + (collab.user_id == user.id ? ' (Me)' : '')"
        [item]="collab"
        [includeChevron]="collab.user_id"
        [subData]="[collab.role | uppercase]"
        (itemClicked)="collabClick(collab)"
      >
        <div class="button-content">
          @if (activeUsers && !activeUsers[collab.user_id] && collab.status == "pending") {
            <div class="text-right text-nowrap m-r-5">
              <fa-icon icon="paper-plane" placement="left" (click)="resendInvite(collab.email, $event)" [ngbTooltip]="'Resend Invite'" class="action circle-icon-btn m-r-10"></fa-icon>
              <span class="collab-status pending">{{ "sphere.workspaces.pending" | translate }}</span>
            </div>
          }
        </div>
      </myp-list-item>
    }
    @if (myWorkspace) {
      <button class="small-btn" (click)="manageCollaborators()">{{ "sphere.workspaces.manage_collaborators" | translate }}</button>
    }
  </div>
</ng-template>
